/**
 * Подписи опасности/этажа для строк «в обход …» — общее для аварийной
 * панели (emergency-escape-notes.tsx) и обычного маршрута (route-panel.tsx).
 * Выделено 24.09.2026 (City Resilience Hack, живая тревога v2).
 */
import { getLang, tr } from '@app/i18n'
import { localized, type Venue } from '@app/rvf'
import type { PointHazardKind, RouteDetour } from '../emergency/alert-types'

const KIND_KEY: Readonly<Record<PointHazardKind, Parameters<typeof tr>[0]>> = {
  fire: 'hazard.kind.fire',
  smoke: 'hazard.kind.smoke',
  flood: 'hazard.kind.flood',
  danger: 'hazard.kind.danger',
  closed: 'hazard.kind.closed',
}

/** Название вида опасности обхода; 'units' (горящие помещения живой тревоги) — своя строка. */
export function detourKindLabel(kind: RouteDetour['kind']): string {
  if (kind === 'units') return tr('route.detour_zone')
  return tr(KIND_KEY[kind])
}

/** Имя этажа по id уровня RVF; null — не знаем/на всех этажах. */
export function levelName(v: Venue, levelId: string | null): string | null {
  if (!levelId) return null
  const level = v.levels.find((l) => l.id === levelId)
  if (!level) return null
  return localized(level.name, getLang(), v.venue.default_language) || null
}
